import { Button, Layout, Icon } from 'components'
import { useEffect, useState } from 'react'
import styles from './AccountingPage.module.scss'

import { useDispatch, useSelector } from 'react-redux'

import right from 'assets/icons/chevron_right.png'

import { useLocation, useNavigate } from 'react-router-dom'


import CheckContent from './components/CheckContent';
import CourseContent from './components/CourseContent';
import AcademicYearContent from './components/AcademicYearContent';
import EducationTypeContent from './components/EducationTypeContent';

import StructureContent from './components/StructureContent/StructureContent';

import PositionContent from './components/PositionContent';

import AllowanceCategoryContent from './components/AllowanceCategoryContent';
import DeductionTypeContent from './components/DeductionTypeContent';

import { getAccountingDetailData, getCheckData } from "service/AccountingService";

import userInfo from 'utils/userInfo'
const AccountingPageStruct = () => {
  const navigate = useNavigate()
  const sections = [
    
    { key: "structure", label: "Структура", Component: StructureContent },
    { key: "position", label: "Должности", Component:  PositionContent },
    { key: "checks", label: "Счета", Component: CheckContent },
    { key: "academicyear", label: "Годы обучения", Component: AcademicYearContent },
    { key: "educationtype", label: "Виды обучения", Component: EducationTypeContent },
    { key: "course", label: "Курсы", Component: CourseContent },
    { key: "allowancecategory", label: "Категории надбавок", Component: AllowanceCategoryContent },
    { key: "deductiontype", label: "Виды удержаний", Component: DeductionTypeContent },
  ];

  const [activeSection, setActiveSection] = useState(null);

  const handleShowSection = (key) => {
    setActiveSection(prev => (prev === key ? null : key));
  };


  const [render, setRender] = useState(false)
  const location = useLocation()
  const [id, setId] = useState(null);
  const [data, setData] = useState([]);
  const [datacheck, setDataCheck] = useState([]);
  const getData = async (id) => {
    try {
      let response = await getAccountingDetailData(id, data);
      let responsecheck = await getCheckData(id, data);
      setData(response.data);
      setDataCheck(responsecheck.data);

    } catch (error) {
    }
  };

  useEffect(() => {
    if (location.state && location.state.usedId) {

      const usedId = location.state.usedId;

      setId(usedId)

      getData(usedId);

      setRender(false);
    } else {

      navigate("/accounting");
    }


  }, [render, location.pathname, location.state]);

  return (
    <div className={styles.project__body_second}>
      <div >
        <div className={styles.project__menu}>
          {sections.map(({ key, label }) => (
            <div key={key} className={
              activeSection === key
                ? styles.project__menu__item__active
                : styles.project__menu__item
            }>
              <h2
                onClick={() =>
                  handleShowSection(activeSection === key ? null : key)
                }
                style={{ cursor: 'pointer' }}
              >
                {label} <Icon name={activeSection === key ? 'chevronUp' : 'chevronDown'} />
              </h2>
            </div>
          ))}
        </div>
      </div>
      <div >
        {sections.map(({ key, Component }) =>
          activeSection === key && Component ? (
            <Component
              key={key}
              render={render}
              setRender={setRender}
              datacheck={datacheck}
              id={id}
            />
          ) : null
        )}
      </div>
    </div>


  )
}

export default AccountingPageStruct
